import gql from 'graphql-tag'

export default {
  ASSIGN_TAGS_TO_USER: gql`
    mutation assignTagsToUser(
      $projectUid: String!
      $userUid: String!
      $tagIds: [ID!]
    ) {
      assignTagsToUser(
        projectUid: $projectUid
        userUid: $userUid
        tagIds: $tagIds
      ) {
        message
        status
      }
    }
  `,
}
